// gen
// const baseUrl = "http://fangke.tulangbao.com/index";
const baseUrl = "https://visit.xizangtouzi.com/index";
// dev
// const baseUrl = "http://ytmf.liuyunchuan.com/index";

export default {
  baseUrl
};



// WEBPACK FOOTER //
// ./src/global/constant.js